import React from 'react';
import { IconText } from '@ui';
import './index.scss';
import icons from '@icons';

const {
  edit: { black: editOutlinedDarkGrey, darkGrey: editOutlinedGrey },
  trash2: { black: trashOutlinedBlack, darkGrey: trashOutlinedGrey }
} = icons.Outline;
const ReviewControlBtns = ({
  answer,
  openEditReviewModal,
  onDeleteReviewClickHandler
}) => (
  <div
    className={`ReviewControlBtns${!answer ? ' ReviewControlBtns--no-mb' : ''}`}
  >
    {answer && <div className='ReviewControlBtns__divider' />}
    <IconText
      className='ReviewControlBtns__btn'
      icon={editOutlinedGrey.x3}
      iconHover={editOutlinedDarkGrey.x3}
      text='Редактировать'
      onClick={openEditReviewModal}
      fontSize='14'
      height='20'
      marginRight='8'
      hoverColor='black'
      withCursor
    />
    <IconText
      className='ReviewControlBtns__btn'
      icon={trashOutlinedGrey.x3}
      iconHover={trashOutlinedBlack.x3}
      text='Удалить'
      onClick={onDeleteReviewClickHandler}
      fontSize='14'
      height='20'
      marginRight='8'
      hoverColor='black'
      withCursor
    />
  </div>
);

export default ReviewControlBtns;
